export const AttemptedActionKey = 'attempted';
